export default __webpack_public_path__ + "static/media/r5.b02399dc.jpg";